import {filesize} from 'filesize'

export default (size)=> {
	return filesize(size, {round:0})
}
